"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PenaltySubcategories = exports.PenaltySubcategory = exports.PenaltyCategories = exports.PenaltyCategory = void 0;
var PenaltyCategory;
(function (PenaltyCategory) {
    PenaltyCategory["DRIVER_NO_SHOW"] = "driver_no_show";
    PenaltyCategory["DIFFERENT_DRIVER_VEHICLE"] = "different_driver_vehicle";
    PenaltyCategory["DANGEROUS_DRIVING"] = "dangerous_driving";
    PenaltyCategory["DELAY"] = "delay";
    PenaltyCategory["CAR_CONDITIONS"] = "car_conditions";
    PenaltyCategory["DT_STANDARDS_NOT_MET"] = "dt_standards_not_met";
    PenaltyCategory["ITINERARY_ISSUES"] = "itinerary_issues";
    PenaltyCategory["DRIVER_CANCELS_CONFIRMED_RIDE"] = "driver_cancels_confirmed_ride";
    PenaltyCategory["PENALTY_FOR_REPLACEMENT"] = "penalty_for_replacement";
    PenaltyCategory["COLLECTING_CASH_NOT_APPROVED"] = "collecting_cash_not_approved";
    PenaltyCategory["TRIP_NOT_COMPLETED"] = "trip_not_completed";
    PenaltyCategory["MISSING_TRACKING"] = "missing_tracking";
    PenaltyCategory["MISSING_INVOICE"] = "missing_invoice";
    PenaltyCategory["BALANCE_ADJUSTMENT"] = "balance_adjustment";
    PenaltyCategory["CHILDSEAT_ISSUES"] = "childseat_issues";
    PenaltyCategory["OTHER"] = "other";
})(PenaltyCategory || (exports.PenaltyCategory = PenaltyCategory = {}));
exports.PenaltyCategories = {
    [PenaltyCategory.DRIVER_NO_SHOW]: "Driver no show",
    [PenaltyCategory.DIFFERENT_DRIVER_VEHICLE]: "Different driver or vehicle",
    [PenaltyCategory.DANGEROUS_DRIVING]: "Dangerous driving",
    [PenaltyCategory.DELAY]: "Delay",
    [PenaltyCategory.CAR_CONDITIONS]: "Car conditions",
    [PenaltyCategory.DT_STANDARDS_NOT_MET]: "DT Standards not met",
    [PenaltyCategory.ITINERARY_ISSUES]: "Itinerary issues",
    [PenaltyCategory.DRIVER_CANCELS_CONFIRMED_RIDE]: "Driver cancels confirmed ride",
    [PenaltyCategory.PENALTY_FOR_REPLACEMENT]: "Penalty for replacement",
    [PenaltyCategory.COLLECTING_CASH_NOT_APPROVED]: "Collecting cash when it's not approved",
    [PenaltyCategory.TRIP_NOT_COMPLETED]: "Trip not completed",
    [PenaltyCategory.MISSING_TRACKING]: "Missing tracking",
    [PenaltyCategory.MISSING_INVOICE]: "Missing invoice",
    [PenaltyCategory.BALANCE_ADJUSTMENT]: "Balance adjustment",
    [PenaltyCategory.CHILDSEAT_ISSUES]: "Childseat issues",
    [PenaltyCategory.OTHER]: "Other",
};
var PenaltySubcategory;
(function (PenaltySubcategory) {
    PenaltySubcategory["DIFFERENT_DRIVER"] = "different_driver";
    PenaltySubcategory["DIFFERENT_VEHICLE"] = "different_vehicle";
    PenaltySubcategory["SPEEDING"] = "speeding";
    PenaltySubcategory["TEXTING"] = "texting";
    PenaltySubcategory["DRIVING_WHILE_SICK"] = "driving_while_sick";
    PenaltySubcategory["DUI"] = "dui";
    PenaltySubcategory["FALLING_ASLEEP"] = "falling_asleep";
    PenaltySubcategory["USING_PHONE"] = "using_phone";
    PenaltySubcategory["AC"] = "ac";
    PenaltySubcategory["FLAT_TIRE"] = "flat_tire";
    PenaltySubcategory["HARASSING"] = "harassing";
    PenaltySubcategory["MEET_AND_GREET"] = "meet_and_greet";
    PenaltySubcategory["WATER"] = "water";
    PenaltySubcategory["SELLING_ANYTHING"] = "selling_anything";
    PenaltySubcategory["OFFER_TRIPS_OUTSIDE_DT"] = "offer_trips_outside_dt";
    PenaltySubcategory["OTHER_PEOPLE_IN_CAR"] = "other_people_in_car";
    PenaltySubcategory["NOT_PREPARED_STOP"] = "not_prepared_stop";
    PenaltySubcategory["MISSED_STOP"] = "missed_stop";
    PenaltySubcategory["DRIVER_GOT_LOST"] = "driver_got_lost";
    PenaltySubcategory["WRONG_DROPOFF"] = "wrong_dropoff";
    PenaltySubcategory["MANUAL_CANCELLATION_PENALTY"] = "manual_cancellation_penalty";
    PenaltySubcategory["AUTOMATED_CANCELLATION_PENALTY"] = "automated_cancellation_penalty";
    PenaltySubcategory["COLLECTING_CASH_FOR_PAID_TRIP"] = "collecting_cash_for_paid_trip";
    PenaltySubcategory["ASKING_FOR_TOLLS"] = "asking_for_tolls";
    PenaltySubcategory["OTHER"] = "other";
})(PenaltySubcategory || (exports.PenaltySubcategory = PenaltySubcategory = {}));
exports.PenaltySubcategories = {
    [PenaltyCategory.DRIVER_NO_SHOW]: {},
    [PenaltyCategory.DIFFERENT_DRIVER_VEHICLE]: {
        [PenaltySubcategory.DIFFERENT_DRIVER]: "Different driver",
        [PenaltySubcategory.DIFFERENT_VEHICLE]: "Different vehicle",
        [PenaltySubcategory.OTHER]: "Other",
    },
    [PenaltyCategory.DANGEROUS_DRIVING]: {
        [PenaltySubcategory.SPEEDING]: "Speeding",
        [PenaltySubcategory.TEXTING]: "Texting",
        [PenaltySubcategory.DRIVING_WHILE_SICK]: "Driving while sick",
        [PenaltySubcategory.DUI]: "DUI",
        [PenaltySubcategory.FALLING_ASLEEP]: "Falling asleep",
        [PenaltySubcategory.USING_PHONE]: "Using phone",
        [PenaltySubcategory.OTHER]: "Other",
    },
    [PenaltyCategory.DELAY]: {},
    [PenaltyCategory.CAR_CONDITIONS]: {
        [PenaltySubcategory.AC]: "AC",
        [PenaltySubcategory.FLAT_TIRE]: "Flat tire",
        [PenaltySubcategory.OTHER]: "Other",
    },
    [PenaltyCategory.DT_STANDARDS_NOT_MET]: {
        [PenaltySubcategory.HARASSING]: "Harassing",
        [PenaltySubcategory.MEET_AND_GREET]: "Meet and greet",
        [PenaltySubcategory.WATER]: "Water",
        [PenaltySubcategory.SELLING_ANYTHING]: "Selling anything",
        [PenaltySubcategory.OFFER_TRIPS_OUTSIDE_DT]: "Offer trips outside DT",
        [PenaltySubcategory.OTHER_PEOPLE_IN_CAR]: "Other people in car",
        [PenaltySubcategory.OTHER]: "Other",
    },
    [PenaltyCategory.ITINERARY_ISSUES]: {
        [PenaltySubcategory.NOT_PREPARED_STOP]: "Not prepared stop",
        [PenaltySubcategory.MISSED_STOP]: "Missed stop",
        [PenaltySubcategory.DRIVER_GOT_LOST]: "Driver got lost",
        [PenaltySubcategory.WRONG_DROPOFF]: "Wrong dropoff",
        [PenaltySubcategory.OTHER]: "Other",
    },
    [PenaltyCategory.DRIVER_CANCELS_CONFIRMED_RIDE]: {
        [PenaltySubcategory.MANUAL_CANCELLATION_PENALTY]: "Manual cancellation penalty",
        [PenaltySubcategory.AUTOMATED_CANCELLATION_PENALTY]: "Automated cancellation penalty",
        [PenaltySubcategory.OTHER]: "Other",
    },
    [PenaltyCategory.PENALTY_FOR_REPLACEMENT]: {},
    [PenaltyCategory.COLLECTING_CASH_NOT_APPROVED]: {
        [PenaltySubcategory.COLLECTING_CASH_FOR_PAID_TRIP]: "Collecting cash for paid trip",
        [PenaltySubcategory.ASKING_FOR_TOLLS]: "Asking for tolls",
        [PenaltySubcategory.OTHER]: "Other",
    },
    [PenaltyCategory.TRIP_NOT_COMPLETED]: {},
    [PenaltyCategory.MISSING_TRACKING]: {},
    [PenaltyCategory.MISSING_INVOICE]: {},
    [PenaltyCategory.BALANCE_ADJUSTMENT]: {},
    [PenaltyCategory.CHILDSEAT_ISSUES]: {},
    [PenaltyCategory.OTHER]: {},
};
//# sourceMappingURL=PenaltyCategory.js.map